// Brand button — inked "printer's block" look. One citrus primary, one ghost.

import type { ButtonHTMLAttributes, ReactNode } from "react";

type Variant = "primary" | "ghost";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  loading?: boolean;
  children: ReactNode;
}

const base =
  "inline-flex items-center justify-center gap-2 rounded-xl px-5 py-3 font-semibold " +
  "transition-transform duration-100 select-none disabled:opacity-60 disabled:cursor-not-allowed " +
  "active:translate-x-[2px] active:translate-y-[2px] active:shadow-none";

const variants: Record<Variant, string> = {
  primary: "bg-citrus text-paper border-2 border-ink shadow-[3px_3px_0_0_var(--color-ink)] hover:bg-citrus-bright",
  ghost: "bg-paper-deep text-ink border-2 border-ink shadow-[2px_2px_0_0_var(--color-ink)] hover:bg-paper-edge",
};

export function Button({ variant = "primary", loading = false, children, disabled, className, ...rest }: ButtonProps & { className?: string }) {
  return (
    <button className={`${base} ${variants[variant]}${className ? ` ${className}` : ""}`} disabled={disabled || loading} {...rest}>
      {loading ? (
        <span
          className="h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent"
          aria-hidden
        />
      ) : null}
      <span>{children}</span>
    </button>
  );
}
